import {
  Offer,
} from "@assets/types"

import {
  promotionHasPaymentMethod,
  promotionHasMassiveSeal,
} from '@assets/utils'

export const promotionHasSeals = (promotion: Offer | undefined) => promotionHasPaymentMethod(promotion) || promotionHasMassiveSeal(promotion)